<template>
  <panel-navigation>
    <h1 class="text-lg font-semibold mb-3">Roadmap</h1>

    <hr class="border-b border-gray-100 mb-3">

    <div class="dashboard-box stats-box w-full px-2 -mx-2">
      <v-card
        class="pa-2 h-full"
        tile
      >
        <div v-if="me" class="w-full mb-3 p-3">
          <p class="mb-1 text-xs mb-2">
            At Accelerate Marketing, our users guide our development. Have a great feature suggestion? Add it, or browse the existing requests and vote for what you would like to see integrated within the app.

            <br><br>

            When you add a feature request, please include a screenshot or video and be as detailed as possible in your description, so that we fully understand what your request is about. Feel free to browse our existing requests to get a grasp on how to best submit your own ideas.

            <br><br>

            Suggested screenshot/video apps you can use:

            <br><br>

            - <a href="https://zight.com/">https://zight.com/</a> (screenshot & video)<br>
            - <a href="https://www.screencast.com/">https://www.screencast.com/</a> (screenshot & video)<br>
            - <a href="https://www.loom.com/">https://www.loom.com/</a> (video only)<br>
            - <a href="https://www.veed.io/">https://www.veed.io/</a> (video only)
          </p>

          <!-- <div data-upvoty></div> -->
        </div>
      </v-card>
    </div>
  </panel-navigation>
</template>

<script>
import { mapState } from 'vuex'
import PanelNavigation from '@/components/PanelNavigation.vue'

export default {
  metaInfo () {
    return {
      title: 'Roadmap | ' + this.$appName
    }
  },

  components: {
    PanelNavigation
  },

  computed: {
    ...mapState({
      me: state => state.me.me,
      profile: state => state.me.profile
    })
  },

  data () {
    return {}
  },

  methods: {}
}
</script>
